import { render, staticRenderFns } from "./OrderOverviewProductData.vue?vue&type=template&id=11cf5118&scoped=true"
import script from "./OrderOverviewProductData.vue?vue&type=script&lang=ts"
export * from "./OrderOverviewProductData.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OrderOverviewProductData.vue?vue&type=style&index=0&id=11cf5118&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "11cf5118",
  null
  ,true
)

export default component.exports